import React, { useMemo } from 'react';

import { expValEquals, expVal } from '@confluence/feature-experiments';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';

import { getSmartLinksBoundaryNameForUrl } from './smartLinkBatchHelpers.ts';

// Suspense wrapper to be passed to ADF Renderer
function SuspenseWrapperForUrl({ url, children }) {
	if (!url || !expVal('confluence_smartlinks_suspense', 'isEnabled', false)) {
		return children;
	}
	const fetcherName = getSmartLinksBoundaryNameForUrl(url);
	return (
		<SuspenseWithDataFetcher dataFetcherName={fetcherName}>{children}</SuspenseWithDataFetcher>
	);
}

// Put initialState into a getter
export const useStoreOptions = (initialState: any, isPageSSRd: boolean): any =>
	useMemo(() => {
		if (
			initialState &&
			(isPageSSRd || expValEquals('platform_editor_smartlink_local_cache', 'isEnabled', true))
		) {
			return {
				storeOptions: {
					initialState,
				},
				SuspenseWrapperForUrl,
			};
		} else {
			return {};
		}
	}, [initialState, isPageSSRd]);
